import { Component, forwardRef, ViewChild } from '@angular/core';
import { faCheck, faTimes, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { EntityVerificationPdfComponent } from '../entity-verification-pdf/entity-verification-pdf.component';
import { MatDialogRef } from '@angular/material/dialog';
import { Environment } from 'src/app/core/environment/environment';
import { SessionStorageService } from 'ngx-webstorage';
import { EntityService } from '../entity.service';
import { NgForm } from '@angular/forms';
@Component({
    selector: 'nphs-wo-entity-confirmation-form',
    templateUrl: './entity-confirmation-form.component.html',
    styleUrls: ['./entity-confirmation-form.component.scss'],
    standalone: false
})
export class EntityConfirmationFormComponent {
  @ViewChild(forwardRef(() =>EntityVerificationPdfComponent)) pdfComponent!: EntityVerificationPdfComponent;
  

  constructor(
    private entityService:EntityService,
    public entityConfirmformDialogRef: MatDialogRef<EntityConfirmationFormComponent>,
    private sessionStorage: SessionStorageService
  ) { }

  additionalEmails:any;
  submitted:boolean = false;

  faCheck = faCheck;
  faFilePdf = faFilePdf;
  faTimes = faTimes
  pdfType:string ='print';
  formData: any = this.entityService.getFormValue();
  wo340BEmailInquires = Environment.getInstance().appConfig.nuctrac340BEmailInquires;
  loggedInUserEmailId = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.Email) ?
  this.sessionStorage.retrieve(CacheConstant.SessionStorageData.Email) : '';
  adminEmail =this.formData.hospital340BAdministratorEmail;
  customerShipToNum: number = this.sessionStorage.retrieve(CacheConstant.SessionStorageData.ShipTo)
  

  generatePdf(){   
    setTimeout(()=>{ 
      if(this.pdfComponent.generatePdf){
        this.pdfComponent.generatePdf(null); 
      }                
    },700);
  }

  submit(form: NgForm,pdfType){

    if(pdfType === 'print'){
      this.pdfType = 'print';
    }
    else{
      this.submitted = true;
      if (form.invalid) {
        return;
      }
      this.pdfType = 'email';            
      const emailList = form.value.email.split(",");
      this.formData.additionalEmails = emailList;
      this.formData = { ...this.formData, additionalEmails:emailList };         
      this.submitted = false;
      form.resetForm();                 
    }    
    this.generatePdf();  

  }
  
  close(){
    this.entityConfirmformDialogRef.close()
  }
}

